import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    border: 'none',
    position: 'relative',
    minWidth: 325,
    transition: 'transform ease-in-out 200ms',
    boxShadow: '0 8px 40px 0 rgba(0, 0, 0, 0.10)',

    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
  inviterName: {
    color: theme.colors.gray[6],
  },
  contentLink: {
    color: 'inherit',
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._12,
    cursor: 'pointer',
  },
  contestSection: {
    width: '100%',
  },
  contestInfo: {
    flex: 1,
    minWidth: 0,
  },
  contestName: {
    color: theme.colors.gray[9],
    fontWeight: 800,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
  },
  metaLabel: {
    color: theme.colors.gray[6],
    fontWeight: 500,
  },
  metaValue: {
    color: theme.colors.gray[9],
    fontWeight: 600,
  },
  metaDivider: {
    color: theme.colors.gray[6],
  },
  expiryPrefix: {
    color: theme.colors.gray[6],
  },
  expiryTime: {
    color: theme.colors.orange[3],
  },
  contestMeta: {
    gap: theme.other.spacing._4,
  },
}));

export default useStyles;
